<template>
  <footer class="footr">
    <div class="foo-wrapper">
      <div class="logo">
        <router-link to="/">ComicHub</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>